import { numberOfColumnsLabel, numberOfRowsLabel } from './InsertTableDialog.locstring.json';
import { insertTable } from 'owa-locstrings/lib/strings/inserttable.locstring.json';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import { okButton } from 'owa-locstrings/lib/strings/okbutton.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Dialog, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { OwaModalProps } from 'owa-modal';

let styles = require('./InsertTablePane.scss');

const INPUT_BOX_DEFAULT_VALUE = '3';

type TableSize = {
    colStr: string;
    rowStr: string;
};
type InsertTableDialogProps = OwaModalProps<TableSize | void>;

/**
 * A popup modal that shows text fields for the dimensions of the modal to insert.
 */
const InsertTableDialogInner = ({ onDismiss }: InsertTableDialogProps) => {
    let [colStr, setColStr] = React.useState(INPUT_BOX_DEFAULT_VALUE);
    let [rowStr, setRowStr] = React.useState(INPUT_BOX_DEFAULT_VALUE);
    let onDismissWithoutValue = React.useCallback(() => {
        onDismiss();
    }, [onDismiss, colStr, rowStr]);
    let onDismissWithValue = React.useCallback(() => {
        onDismiss({ colStr, rowStr });
    }, [onDismiss, colStr, rowStr]);
    let onSetColStrFromInput = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setColStr(e.target.value);
        },
        [setColStr]
    );
    let onSetRowStrFromInput = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setRowStr(e.target.value);
        },
        [setRowStr]
    );

    return (
        <Dialog onDismiss={onDismissWithoutValue} hidden={false} title={loc(insertTable)}>
            <div>
                <div className={styles.insertTableDialogRow}>
                    <div className={styles.insertTableDialogCell}>{loc(numberOfColumnsLabel)}</div>
                    <div className={styles.insertTableDialogCell}>
                        <label>
                            <input
                                id="colInput"
                                role="textbox"
                                type="text"
                                maxLength={2}
                                onChange={onSetColStrFromInput}
                                defaultValue={colStr}
                                className={styles.numInput}
                            />
                        </label>
                    </div>
                </div>
                <div className={styles.insertTableDialogRow}>
                    <div className={styles.insertTableDialogCell}>{loc(numberOfRowsLabel)}</div>
                    <div className={styles.insertTableDialogCell}>
                        <input
                            role="textbox"
                            type="text"
                            maxLength={2}
                            onChange={onSetRowStrFromInput}
                            defaultValue={rowStr}
                            className={styles.numInput}
                        />
                    </div>
                </div>
            </div>
            <DialogFooter>
                <PrimaryButton onClick={onDismissWithValue} title={loc(okButton)}>
                    {loc(okButton)}
                </PrimaryButton>
                <DefaultButton onClick={onDismissWithoutValue} title={loc(cancelButton)}>
                    {loc(cancelButton)}
                </DefaultButton>
            </DialogFooter>
        </Dialog>
    );
};

export const InsertTableDialog = observer(InsertTableDialogInner);
